<template>
    <h4 class="group-title"> {{ ' OA code / OA Vendor Name ' + groupCodeDesc }}</h4>
</template>
<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"

export default {
  name: "GroupTitle",
  created() {
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapGetters(["getGroupCode"]),
    ...mapActions(["toggleLoading"]),
  },
  computed: {
    groupCodeDesc() {
      return  this.getGroupCode() ? this.getGroupCode().code + " " + this.getGroupCode().name : ""
    }
  }
}


</script>
<style scoped>
.group-title {
  padding: 12px 0 0 0;
}
</style>
